import { render, staticRenderFns } from "./AnimalNumbersDeer.vue?vue&type=template&id=11ec582a&"
import script from "./AnimalNumbersDeer.vue?vue&type=script&lang=js&"
export * from "./AnimalNumbersDeer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports